/**
 * Created by psherif on 10/12/16.
 */
'use strict';

angular.module('core').directive('faqElement', [
	function () {
		return {
			templateUrl: 'modules/core/views/faq.client.directive.html',
			restrict: 'E',
			scope:
			{
				key : '@'
			},
			replace:true,
			transclude: true,
			link: function(scope, element, attrs, ctrl, transclude) {
				transclude(function(original) {

					var questionTargetElement = element.find('.faq-question');
					var answerTargetElement = element.find('.faq-answer');

					var questionSourceElement = original.filter('question');
					var answerSourceElement = original.filter('answer');

					questionTargetElement.html(questionSourceElement.html());
					answerTargetElement.html(answerSourceElement.html());
				});
			}
		};
	}
]);
